import { Store } from "../interfaces/Store.interface";

/**
 * [Pure] Get value for key or { key: value } object for array of keys from store. 
 * @param key - Property to get from store.
 * @param store - Object to use as store.
 * @param fallback - Result to return if no match found.
 */
export function getValue(key: string | number | any, store: Store, fallback?: any): any {
    if (typeof key === "number") key = key.toString();
    if (typeof key === "string") {
        const keys = key.split(".");                            // "prop1.prop2" -> [ "prop1", "prop2" ]
        for (let i = 0; i < keys.length; i++) {                 // Iterate over property array
            if (!(store instanceof Object)) return fallback;    // If store isn't an object, return fallback.
            if (store[keys[i]] === undefined) return fallback;  // If no value exists at store[prop], return fallback.
            store = store[keys[i]];                             // Otherwise set store to store[prop] and continue iteration.
        }
        return store;
    }
    if (key instanceof Object){
        return Object.keys(key).reduce((obj, prop) => {
            if (["number", "boolean"].indexOf(typeof key[prop]) > -1) { // If given a number or boolean:
                obj[prop] = key[prop];                                  // Set property equal to value.
            }
            if (typeof key[prop] === "string") {                        // If given a string:
                let value = getValue(key[prop], store);                 // Get value at key from store.
                if (value !== undefined) obj[prop] = value;             // If value exists, set property equal to value.
            }
            if (key[prop] instanceof Array) {                                           // If given an array:
                let values = key[prop].slice(0,-1).map(val => getValue(val, store));    // Get values from array arguments.
                let fn = key[prop].slice(-1)[0];                                        // Get function from last array argument.
                let result = fn.apply(null, values);                                    // Use values as arguments for function.
                if (result !== undefined) obj[prop] = result;                           // If function returned value, set property equal to value.
            }
            return obj; // Return new object.
        }, {});
    }
    return undefined;   // Return undefined if key is unexpected type.
}
